// Google Analytics helper
export const pageview = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-BTWYNVDHS6', {
      page_path: url,
      page_title: title,
    });
  }
};

export const event = (action, params) => {
  console.log('🎯 GA Event called:', action, params);
  console.log('🔍 window exists?', typeof window !== 'undefined');
  console.log('🔍 window.gtag exists?', typeof window !== 'undefined' && window.gtag);
  
  if (typeof window !== 'undefined' && window.gtag) {
    console.log('✅ Calling window.gtag now...');
    window.gtag('event', action, params);
    console.log('✅ window.gtag called!');
  } else {
    console.log('❌ window.gtag NOT available!');
  }
};